import React from "react";
import "./Offline.css";
export default props => (
  <div className={"Offline " + (props.backOnline ? "back-online" : "")}>
    {props.backOnline ? "Back online" : "Offline"}
  </div>
);
